import React, { createContext, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import io from 'socket.io-client';
import { addSocketMessage, getChats } from '../actions/chat';
import { getNotifications, addNotification } from '../actions/notification';
import { UPDATE_ONLINE_USERS } from '../actions/types';

export const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
    const dispatch = useDispatch();
    const socket = useRef();
    const { isAuthenticated } = useSelector(state => state.auth);
    const authUser = useSelector(state => state.auth.user || state.user.user);
    const user = authUser;

    useEffect(() => {
        if (isAuthenticated && user && user._id) {
            // Conectar si no existe
            if (!socket.current) {
                const socketUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001';
                socket.current = io(socketUrl, {
                    transports: ['websocket', 'polling'], // Fallback to polling
                    reconnection: true
                });

                socket.current.on('connect', () => {
                    console.log('Socket connected:', socket.current.id);
                    socket.current.emit('join', user._id);
                });

                socket.current.on('notification', (notif) => {
                    dispatch(addNotification(notif));
                });

                socket.current.on('new_message', (data) => {
                    console.log('New socket message received:', data);
                    dispatch(addSocketMessage(data.message, data.chatId, user._id));
                });

                socket.current.on('update_online_users', (userIds) => {
                    console.log('Online users update:', userIds);
                    dispatch({
                        type: UPDATE_ONLINE_USERS,
                        payload: userIds
                    });
                });

                // Cargar datos iniciales
                dispatch(getChats());
                dispatch(getNotifications());
            } else {
                // Si ya existe el socket pero cambió el usuario, nos volvemos a unir
                socket.current.emit('join', user._id);
            }
        }

        return () => {
            if (socket.current && !isAuthenticated) {
                socket.current.disconnect();
                socket.current = null;
            }
        };
    }, [isAuthenticated, user, dispatch]);

    return (
        <SocketContext.Provider value={socket.current}>
            {children}
        </SocketContext.Provider>
    );
};
